import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1f1493d0&scoped=true&"
import script from "./Header.vue?vue&type=script&async=true&lang=js&"
export * from "./Header.vue?vue&type=script&async=true&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=1f1493d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1493d0",
  null
  
)

export default component.exports